import * as Sentry from '@sentry/vue'

export default defineNuxtPlugin((nuxtApp) => {
  const router = useRouter()
  const {
    public: { baseUrl, baseUrlCore, sentry },
  } = useRuntimeConfig()

  if (!sentry.dsn) return

  Sentry.init({
    app: nuxtApp.vueApp,
    dsn: sentry.dsn,
    environment: sentry.environment,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],

    tracesSampleRate: 0.05,
    tracePropagationTargets: [
      'localhost',
      baseUrl,
      baseUrlCore,
    ],
    replaysSessionSampleRate: 0.01,
    replaysOnErrorSampleRate: 0.01,
  })
})
